import PasswordlessLogin from '@/components/Auth/PasswordlessLogin';
import CaireHead from '@/components/CaireHead';
import AppShell from '@/components/layouts/AppShell';
import { PageWithLayout } from '@/types/AppWithLayout';

const PasswordlessLoginPage: PageWithLayout = () => {
  return (
    <>
      <CaireHead title="Login" />
      <PasswordlessLogin />
    </>
  );
};

PasswordlessLoginPage.getLayout = (page) => (
  <AppShell
    narrowContent
    withAgentButton={false}
    withNavigation={false}
    withLoginLink={false}
    withMenu={false}>
    {page}
  </AppShell>
);

export default PasswordlessLoginPage;
